import { Box, Typography, Button, Dialog } from "@mui/material"
import { makeStyles } from '@mui/styles';
import { SnakeLoader } from "../../loader/SnakeLoader";
import { VM } from "../../VM";

export const EmptyList = ({ text }) => {
    return (
        <Box display="flex" alignItems="center" justifyContent="center" mt="3rem">
            <Typography textAlign="center" sx={{ bgcolor: "#fff", display: "inline", p: "5rem", border: "1px solid grey", borderRadius: "10px" }}>{text}</Typography>
        </Box>
    )
}

export const Confirmation = ({isOpen, cancel, send, disabled, status, btnText="Confirm", dsbldTxt, enbldTxt, dsbldTitle = "Disabled this Property?", enbldTitle = "Enabled this Property?" }) => {
    let view = VM()
    const styles = makeStyles(() => ({
        cancel: {
            backgroundColor: '#FFFFFF',
            color: '#1B1B1B',
            borderRadius: view === '/devices/mobile'|| view === '/devices/tablet' ? 4 : 12,
            border: '1px solid #7B7F82',
            height: view === '/devices/mobile'|| view === '/devices/tablet' ? 36 : 44,
            width: view === '/devices/mobile'|| view === '/devices/tablet'? 113 : 132,
            '&:hover':{
                backgroundColor: '#FFFFFF'
            }
        },
        send:{
            backgroundColor: '#11783C',
            color: '#FFFFFF',
            borderRadius: view === '/devices/mobile'|| view === '/devices/tablet' ? 4 : 12,
            height: view === '/devices/mobile'|| view === '/devices/tablet' ? 36 : 44,
            width: view === '/devices/mobile'|| view === '/devices/tablet'? 113 : 132,
            '&:hover':{
                backgroundColor: '#11783C'
            }
        }
    }))
    
    return (
        <Dialog open={isOpen} PaperProps={{ sx:{borderRadius: {xs: '8px !important', md: '14px !important'} } }}>
            <Box display="flex" alignItems="center" flexDirection="column" sx={{py: {xs: 3, md: 4}, px: {xs: 3, md:2,}, width: {md: 432}}}>
                <Typography fontWeight={600} fontSize={22} width="100%" color={ status === 1 ? "error" : "primary" } >
                    { status === 1 ? dsbldTitle : enbldTitle }
                </Typography>
                <Typography fontSize={14} fontWeight={400} textAlign="justify" width="100%" mt="0.5rem">
                    { status === 1 ? dsbldTxt : enbldTxt }
                </Typography>
                <Box display="flex" mt="1rem">
                    <Button variant="contained" className={styles().cancel} sx={{mr: '12px'}} disableElevation={true} onClick={cancel} disabled={disabled}>Cancel</Button>
                    <Button variant="contained" className={styles().send} disableElevation={true} onClick={send} disabled={disabled}> { disabled  ? <SnakeLoader bg= "white" size= "10px" distance= "10px" /> : btnText } </Button>
                </Box>
            </Box>
        </Dialog>
    )
}


export const fieldStyle = () => {
    let s = makeStyles((theme) => ({
        tf: {
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            "& .MuiFormHelperText-root": {
                backgroundColor: "#F0F5F9",
                width: "100%",
                margin: "0 !important",
                paddingLeft: "1rem",
            },
            "& .css-vyjyf0-MuiFormLabel-root-MuiInputLabel-root": {
                color: "#0059BE !important",
            },
            '&:hover fieldset': {
                borderColor: '#11783C !important',
            },
            "& .MuiFormHelperText-root.Mui-error": {
                color: "#F3284B !important"
            },
            '& input:valid + fieldset': {
                borderRadius: '12px !important',
            },
            '& .Mui-disabled': {
                borderRadius: '12px !important',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: '12px !important',
            }, 
            '.css-1ewifw0-MuiButtonBase-root-MuiChip-root':{
                backgroundColor:'#558AC7 !important',
                borderRadius:'10px'
            }
        },
    }));

    return s();
};
